const PostCategory = () =>
  import(
    /* webpackChunkName: "blog-blog-post-category" */ '@/pages/blog/blog/post-category/index.vue'
  )
const CreatePostCategory = () =>
  import(
    /* webpackChunkName: "blog-blog-post-category" */ '@/pages/blog/blog/post-category/create.vue'
  )
const EditPostCategory = () =>
  import(
    /* webpackChunkName: "blog-blog-post-category" */ '@/pages/blog/blog/post-category/edit.vue'
  )

export default {
  path: 'post-category',
  meta: {
    label: 'postCategory',
    auth: 'postCategory'
  },
  component: {
    name: 'PostCategory',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BlogPostCategory',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: PostCategory
    },
    {
      name: 'BlogCreatePostCategory',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreatePostCategory
    },
    {
      name: 'BlogEditPostCategory',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditPostCategory,
      props: true
    }
  ]
}
